import { create } from "zustand";
import { CurrentStatusEnum } from "../Hooks/useGlobalConfigs";

export type GlobalConfigsType = {
    checktokProductFilterEnabled: boolean;
    checktokProductGroupFilterEnabled: boolean;
    configVersion: number;
    contentSearchOnInputVersion: string;
    createCommentAddLinkEnabled: boolean;
    createMessageAddLinkEnabled: boolean;
    dataStatus: CurrentStatusEnum;
    groupChatMaxParticipants: number;
    groupRatingPageEnabled: boolean;
    groupRatingsFeedMax: number;
    groupRatingsSwiperMax: number;
    isAvatarGenerationEnabled: boolean;
    maxDashboardPostsCount: number;
    maxDashboardRecommendedGroupsCount: number;
    maxFallbackContentSearch: number;
    maxHelpfulUsersCount: number;
    maxParentGroupPostsCount: number;
    maxReisweltItemsCount: number;
    maxSuggestedNewsCount: number;
    maxSuggestedPostsCount: number;
    openQuestionsMax: number;
    tippspielCommentSuggestionsAuthorizedUsers: string;
    tippspielCommentSuggestionsEnabled: boolean;
    tippspielCreatePostAddLinkEnabled: boolean;
    tippspielCreatePostAddLocationEnabled: boolean;
    tippspielCreatePostAddPollEnabled: boolean;
    tippspielCreatePostAddVideoEnabled: boolean;
    tippspielFeedCreatePostEnabled: boolean;
    tippspielFeedCreatePostPlaceholder: string;
    tippspielFeedEnabled: boolean;
    tippspielFeedGroups: string;
    tippspielFeedImageGalleryEnabled: boolean;
    tippspielFeedSortingEnabled: boolean;
    tippspielFeedVideoGalleryEnabled: boolean;
    tippspielPromotionSegmentHeadline: string;
    tippspielPromotionSegmentPosition: string;
    tippspielPromotionSegmentPosts: string;
    tippspielPromotionSegmentSliderEnabled: boolean;
    truckTourCreatePostAddLinkEnabled: boolean;
    truckTourCreatePostAddLocationEnabled: boolean;
    truckTourCreatePostAddPollEnabled: boolean;
    truckTourCreatePostAddVideoEnabled: boolean;
    truckTourCreatePostEnabled: boolean;
    truckTourFeedCreatePostPlaceholder: string;
};

type GlobalConfigsStoreType = {
    dataStatus: CurrentStatusEnum;
    setConfigs: (newConfigs: GlobalConfigsType) => void;
    setDataStatus: (dataStatus: CurrentStatusEnum) => void;
    configs?: GlobalConfigsType;
};

export const useGlobalConfigsStore = create<GlobalConfigsStoreType>()(
    (set) => ({
        dataStatus: 0,
        setConfigs: (newConfigs: GlobalConfigsType) =>
            set((state) => {
                if (state.configs !== undefined) {
                    return {
                        configs: state.configs,
                    };
                }
                return {
                    configs: newConfigs,
                };
            }),
        setDataStatus: (dataStatus: CurrentStatusEnum) => {
            set({
                dataStatus,
            });
        },
    }),
);
